import React from 'react'
import Script from 'react-load-script'

import ToastActions from 'actions/ToastActions';
import SupportCallButton from 'support/components/SupportCallButton'

const callEndEvent = 'snapcallEvent_callEnd'
const callStartEvent = 'snapcallEvent_callStarting'

const SNAPCALL_BID = 'f1393f303e0911eaac900dd3f449c992'

type State = {
  disabled: boolean,
  isCallActive: boolean,
  loading: boolean,
};

declare var window: {
  addEventListener: (event: string, listener: () => void) => void,
  removeEventListener: (event: string, listener: () => void) => void,
  snapcallAPI: {
    endCall: () => void,
    startCall: (bid: string) => void,
  }
};

export default class SupportCallButtonContainer extends React.Component<{}, State> {
  state: State = {
    disabled: false,
    isCallActive: false,
    loading: true,
  }

  componentDidMount() {
    window.addEventListener(callEndEvent, this.handleCallEnd);
    window.addEventListener(callStartEvent, this.handleCallStart);
  }

  componentWillUnmount() {
    window.removeEventListener(callEndEvent, this.handleCallEnd);
    window.removeEventListener(callStartEvent, this.handleCallStart);
  }

  handleCallEnd = () => {
    this.setState({
      disabled: true,
      isCallActive: false,
    })

    ToastActions.showSuccessToast('Call ended');
  }

  handleCallStart = () => {
    ToastActions.showSuccessToast('Call is starting');
  }

  handleClick = () => {
    const { isCallActive } = this.state

    if (isCallActive !== true) {
      this.setState({ loading: true })

      const callStarted = window.snapcallAPI.startCall(SNAPCALL_BID);

      this.setState({ loading: false })

      if (callStarted !== undefined) {
        this.setState({ isCallActive: true })
      } else {
        this.setState({ disabled: true })

        ToastActions.showErrorToast('Something went wrong when trying to start a call')
        console.error('SupportCallButtonContainer - Call start failed');
      }
    } else {
      window.snapcallAPI.endCall()

      this.setState({ isCallActive: false })
    }
  }

  handleScriptError = () => {
    this.setState({
      disabled: true,
      loading: false,
    })
    console.error('SupportCallButtonContainer - SnapCall API failed to load');
  }

  handleScriptLoad = () => {
    this.setState({ loading: false })
  }

  render() {
    const { disabled, isCallActive, loading } = this.state

    return (
      <>
        <SupportCallButton
          {...this.props}
          disabled={disabled}
          isCallActive={isCallActive}
          loading={loading}
          onClick={this.handleClick}
        />
        <Script
          url="https://snap.snapcall.io/snapapp.min.js"
          onError={this.handleScriptError}
          onLoad={this.handleScriptLoad}
        />
      </>
    )
  }
}
